// Copyright (c) Microsoft Corporation.
// Licensed under the MIT license.
var _Log_entries, _Log_label, _Log_parent;
import { __classPrivateFieldGet, __classPrivateFieldSet } from "tslib";
import { ErrorCode } from "./error.js";
var LogLevel;
(function (LogLevel) {
    LogLevel[LogLevel["DEBUG"] = 0] = "DEBUG";
    LogLevel[LogLevel["INFO"] = 1] = "INFO";
    LogLevel[LogLevel["WARNING"] = 2] = "WARNING";
    LogLevel[LogLevel["ERROR"] = 3] = "ERROR";
})(LogLevel || (LogLevel = {}));
class Log {
    constructor(context) {
        _Log_entries.set(this, void 0);
        _Log_label.set(this, void 0);
        _Log_parent.set(this, void 0);
        // get all items at the specified logLevel and above (e.g. 'info' will return info, warnings, and errors)
        this.entries = (level = LogLevel.WARNING) => __classPrivateFieldGet(this, _Log_entries, "f").filter(e => e.level >= level);
        this.debug = (message) => this.add(message, LogLevel.DEBUG);
        this.info = (message) => this.add(message, LogLevel.INFO);
        this.warn = (message, code = ErrorCode.ERROR) => this.add(message, LogLevel.WARNING, code);
        this.error = (message, code = ErrorCode.ERROR, fatal = false) => this.add(message, LogLevel.ERROR, code, fatal);
        this.fatal = (message, code = ErrorCode.ERROR) => this.add(message, LogLevel.ERROR, code, true);
        //
        // Customize JSON.stringify() output
        //
        this.toJSON = () => {
            return this;
        };
        //
        // Customize toString() output
        //
        this.toString = () => {
            return JSON.stringify(this);
        };
        __classPrivateFieldSet(this, _Log_label, '', "f");
        __classPrivateFieldSet(this, _Log_entries, [], "f");
        __classPrivateFieldSet(this, _Log_parent, context, "f");
    }
    // is one of the errors fatal? (fatal error stops the decoding/validation process)
    get isFatal() {
        return __classPrivateFieldGet(this, _Log_entries, "f").some(e => e.fatal);
    }
    set label(label) {
        __classPrivateFieldSet(this, _Log_label, label, "f");
    }
    add(logItem, level = LogLevel.ERROR, code = ErrorCode.NOERROR, fatal = false) {
        if (logItem instanceof Log) {
            __classPrivateFieldSet(this, _Log_entries, __classPrivateFieldGet(this, _Log_entries, "f").concat(logItem.entries()), "f");
        }
        else {
            __classPrivateFieldGet(this, _Log_entries, "f").push({ message: logItem, code, fatal, level, label: __classPrivateFieldGet(this, _Log_label, "f") });
        }
        return __classPrivateFieldGet(this, _Log_parent, "f");
    }
}
_Log_entries = new WeakMap(), _Log_label = new WeakMap(), _Log_parent = new WeakMap();
export { LogLevel, ErrorCode, Log };
